import React, { useState } from 'react';

import { Checkbox, FormControlLabel } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { TextFieldSearch } from 'embeds/components';
import { LumaTheme } from 'embeds/core/styles/getTheme';
import { noop } from 'lodash';

import { useFiltersContext } from '../FiltersDialogContext';
import IconAllChecked from '../icons/IconAllChecked';
import IconAllUnchecked from '../icons/IconAllUnchecked';

const styles = ({ spacing: { unit } }: LumaTheme) =>
  createStyles({
    headerWrapper: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: unit * 3,
    },
    selectAllCheckbox: {
      color: 'transparent !important',
    },
    hidden: {
      opacity: 0,
    },
  });

interface FiltersSelectHeaderProps extends WithStyles<typeof styles> {
  remoteCount?: Number;
  type: string;
  items?: any[];
  onSearchChange?: (search: string) => void;
}

const FiltersSelectHeader: React.FC<FiltersSelectHeaderProps> = ({ classes, type, items, onSearchChange = noop }) => {
  const { filters, count, selectAll } = useFiltersContext();
  const [query, setQuery] = useState('');
  const listItems = items || [];

  const itemsCount = count[type] || listItems.length;

  const handleOnChange = (value: string) => {
    setQuery(value);
    onSearchChange(value);
  };

  const filtersType = filters[type] || [];
  // Check if all items are selected.
  const isAllChecked =
    (filtersType.includes('all') && filtersType.length === 1) ||
    (!filtersType.includes('all') && filtersType.length === count[type]);

  return (
    <div className={classes.headerWrapper}>
      <FormControlLabel
        className={classnames({ [classes.hidden]: !!query })}
        control={
          <Checkbox
            disabled={!!query}
            onClick={() => selectAll(type)}
            icon={<IconAllUnchecked fontSize="small" />}
            checkedIcon={<IconAllChecked fontSize="small" />}
            classes={{
              root: classes.selectAllCheckbox,
            }}
            checked={isAllChecked}
          />
        }
        label={`Select All (${itemsCount})`}
      />
      <TextFieldSearch value={query} size="small" onChange={handleOnChange} />
    </div>
  );
};

export default withStyles(styles)(FiltersSelectHeader);
